module.exports = __webpack_public_path__ + "img/deans-lister2019-2020-2nd-term.52894c56.png";